export const YES_NO = [
  { id: true, displayValue: 'Yes' },
  { id: false, displayValue: 'No' },
];
